export default __webpack_public_path__ + "static/media/Use_case_bibliography_documentation.76f7e20d.jpg";